import * as screenfull from 'screenfull';

export default class AppState {
    constructor() {
        this.isFullscreenAvailable = screenfull.isEnabled;
        this.showFullscreenBtn = screenfull.isEnabled;
        this.isFullscreen = screenfull.isEnabled ? screenfull.isFullscreen : false;
        this.showDevTools = false;
    }
}